import {
  TeamActionTypes,
  CustomTeamTokenParams,
  TeamQueryParams
} from './types';
import { action } from 'typesafe-actions';

export const setCurrentTeam = (team: {
  id: number;
  name: string;
  shape: any;
  baseMapType?: string;
  baseMapId?: string;
  teamDefaultValues?: any;
}) => action(TeamActionTypes.SET_CURRENT_TEAM, team);

export const setCustomTeamBaseMapCredential = (credential: {
  key: string;
  secret: string;
}) => action(TeamActionTypes.SET_CUSTOM_TEAM_BASE_MAP_CREDENTIAL, credential);

export const resetCustomTeamBaseMap = () =>
  action(TeamActionTypes.RESET_CUSTOM_TEAM_BASE_MAP);

export const disableTeamPicker = (flag: boolean) =>
  action(TeamActionTypes.DISABLE_TEAM_PICKER, flag);

export const getCustomTeamBaseMapTokenStart = (params: CustomTeamTokenParams) =>
  action(TeamActionTypes.GET_CUSTOM_TEAM_BASE_MAP_TOKEN_START, params);
export const getCustomTeamBaseMapTokenSuccess = (payload: any) =>
  action(TeamActionTypes.GET_CUSTOM_TEAM_BASE_MAP_TOKEN_SUCCESS, payload);
export const getCustomTeamBaseMapTokenFailure = (error: string) =>
  action(TeamActionTypes.GET_CUSTOM_TEAM_BASE_MAP_TOKEN_FAILURE, error);

export const getTeamsListStart = (params: TeamQueryParams) =>
  action(TeamActionTypes.GET_TEAMS_LIST_START, params);
export const getTeamsListSuccess = (data: any) =>
  action(TeamActionTypes.GET_TEAMS_LIST_SUCCESS, data);
export const getTeamsListFailure = (error: string) =>
  action(TeamActionTypes.GET_TEAMS_LIST_FAILURE, error);

export const setTeamBoundaryToggle = (payload: any) =>
  action(TeamActionTypes.SET_TEAM_BOUNDARY_TOGGLE, payload);
